export const TEXT_TYPE = 'text/plain'

export const HTML_TYPE = 'text/html'

export interface CopyContent {
  [TEXT_TYPE]: string
  [HTML_TYPE]: string
}

export const isFirefox = () => {
  try {
    return navigator.userAgent.toLowerCase().includes('firefox')
  } catch (e) {
    console.error(e)
  }
  return false
}

export const writeCopyContentToClipboard = async (copyContent: CopyContent) => {
  if (isFirefox()) {
    const textResult = copyContent[TEXT_TYPE]
    await navigator.clipboard.writeText(textResult)
  } else {
    const clipboardItems = [
      new ClipboardItem(
        Object.entries(copyContent).reduce((acc: { [contentType: string]: Blob }, [contentType, content]) => {
          acc[contentType] = new Blob([content], { type: contentType })
          return acc
        }, {}),
      ),
    ]
    await navigator.clipboard.write(clipboardItems)
  }
}

export const extendCopyContentWithComplianceMessage = (copyContent: CopyContent, complianceMessage?: string): CopyContent => {
  if (!complianceMessage) {
    return copyContent
  }

  const textContent = copyContent[TEXT_TYPE]
  const htmlContent = copyContent[HTML_TYPE]

  return {
    [TEXT_TYPE]: `${textContent}\n\n${complianceMessage}`,
    [HTML_TYPE]: `${htmlContent}\n\n${complianceMessage}`,
  }
}
